import { RebootPage } from './';

export default {
    title: 'Containers/Reboot'
}

export const rebootPage = () => <RebootPage />;
